import {
  Box,
  Flex,
  Image,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "../components/Authentication/Login";
import Signup from "../components/Authentication/Signup";
import PwaInstallPrompt from "../components/PwaInstallPrompt";
import logo from "../assets/Logo.png";
import sideImage from "../assets/msglogo.png";

function Homepage() {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    if (user) navigate("/chats");
  }, [navigate]);

  const isMobile = useBreakpointValue({ base: true, md: false });
  const [tabIndex, setTabIndex] = useState(0); // 0 = Login, 1 = Signup

  return (
    <Flex
      h="100vh"
      w="100vw"
      overflow="hidden"
      bg="white"
      direction={{ base: "column", md: "row" }}
    >
      {/* Left image */}
      {!isMobile && (
        <Box
          flex="1"
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={6}
          bg="gray.50"
        >
          <Image
            src={sideImage}
            alt="Illustration"
            maxH="80%"
            maxW="80%"
            objectFit="contain"
          />
        </Box>
      )}

      {/* Right form */}
      <Flex
        flex="1"
        align="center"
        justify="center"
        p={{ base: 4, md: 8 }}
        bg="white"
      >
        <Box
          w="100%"
          maxW="md"
          p={6}
          bg="white"
          borderRadius="lg"
          boxShadow="lg"
          border="1px solid #e2e8f0"
        >
          <Box display="flex" justifyContent="center" mb={6}>
            <Image src={logo} alt="App Logo" height="40px" />
          </Box>

         <Tabs
  isFitted
  variant="soft-rounded"
  colorScheme="blue"
  index={tabIndex}
  onChange={(index) => setTabIndex(index)}
>
  <TabList mb="1em">
    <Tab _selected={{ color: "white", bg: "#4e64ee" }} _hover={{ bg: "#4e64ee", color: "white" }}>
      Login
    </Tab>
    <Tab _selected={{ color: "white", bg: "#4e64ee" }} _hover={{ bg: "#4e64ee", color: "white" }}>
      Sign Up
    </Tab>
  </TabList>
  <TabPanels>
    <TabPanel>
      <Login />
    </TabPanel>
    <TabPanel>
      <Signup setTabIndex={setTabIndex} />
    </TabPanel>
  </TabPanels>
</Tabs>


          <PwaInstallPrompt />
        </Box>
      </Flex>
    </Flex>
  );
}

export default Homepage;
